/*
document.addEventListener('DOMContentLoaded', function(){
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
    script.onload = function(){
        particlesJS("snow", {
            "particles": {
                "number": {
                    "value": 100,
                    "density": {
                        "enable": true,
                        "value_area": 1200
                    }
                },
                "color": {
                    "value": "#ffffff"
                },
                "opacity": {
                    "value": 0.7,
                    "random": false,
                    "anim": {
                        "enable": false
                    }
                },
                "size": {
                    "value": 5,
                    "random": true,
                    "anim": {
                        "enable": false
                    }
                },
                "line_linked": {
                    "enable": false
                },
                "move": {
                    "enable": true,
                    "speed": 1.5,
                    "direction": "bottom",
                    "random": true,
                    "straight": false,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": true,
                        "rotateX": 300,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "events": {
                    "onhover": {
                        "enable": false
                    },
                    "onclick": {
                        "enable": false
                    },
                    "resize": false
                }
            },
            "retina_detect": true
        });
    }
    document.head.append(script);
}); */

// -- FAQ smooth accordion - collection pages --
function initArgmacFAQ() {
  document.querySelectorAll('.argmac-faq details').forEach(function (det) {
    var sum = det.querySelector('summary');
    if (!sum || det.dataset.faqInit) return;
    det.dataset.faqInit = '1';

    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'faq-arrow-svg');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M5 7.5L10 12.5L15 7.5');
    path.setAttribute('stroke', '#000');
    path.setAttribute('stroke-width', '1.75');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    sum.insertBefore(svg, sum.firstChild);

    det.setAttribute('open', '');

    var wrap = document.createElement('div');
    wrap.className = 'faq-ans';
    wrap.style.height = '0';
    Array.from(det.children).forEach(function (c) {
      if (c !== sum) wrap.appendChild(c);
    });
    det.appendChild(wrap);

    sum.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = det.classList.contains('faq-open');
      if (isOpen) {
        wrap.style.transition = 'none';
        wrap.style.height = wrap.scrollHeight + 'px';
        wrap.offsetHeight;
        wrap.style.transition = 'height 0.35s ease';
        wrap.style.height = '0';
        det.classList.remove('faq-open');
      } else {
        det.classList.add('faq-open');
        wrap.style.transition = 'none';
        wrap.style.height = '0';
        wrap.offsetHeight;
        wrap.style.transition = 'height 0.35s ease';
        wrap.style.height = wrap.scrollHeight + 'px';
        wrap.addEventListener('transitionend', function h() {
          if (det.classList.contains('faq-open')) {
            wrap.style.height = 'auto';
            wrap.style.transition = '';
          }
          wrap.removeEventListener('transitionend', h);
        });
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArgmacFAQ);
} else {
  initArgmacFAQ();
}
